import { render, staticRenderFns } from "./AccountWrapper.vue?vue&type=template&id=a42858d0&"
import script from "./AccountWrapper.vue?vue&type=script&lang=js&"
export * from "./AccountWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports